import styled from 'styled-components';
import { SearchLineIcon } from '../../../components/icon/icon';
import { useForm, Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getObtainsStateList, getObtainsStateSearch } from '../../../api/order';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { orderIdState, selectedItemsState } from '../../../atoms/orderState';
import { formatDate, formatDateTime } from '../../../utils/util';

interface ObtainListItems {
  orderId: number; // 발주 아이디
  obtainId: number; // 수주 아이디
  target: string; // 도착 시간
  vehicle: string; // 차량 번호
  obtainCreatedAt: string; // 수주 시간
}

const OrderStatus = () => {
  const orderId = useRecoilValue(orderIdState); // Recoil 상태 값 가져오기
  const setSelectedItems = useSetRecoilState(selectedItemsState); // 선택된 아이템들 업데이트 함수

  const history = useHistory();
  const { register, handleSubmit, control, reset } = useForm();
  const [checkedItems, setCheckedItems] = useState<{ [key: number]: boolean }>(
    [],
  );
  const [data, setData] = useState<ObtainListItems[] | null>(null); // 데이터 상태
  const [loading, setLoading] = useState<boolean>(true); // 로딩 상태 추가

  const onSubmitSearch = async (data: any) => {
    try {
      setLoading(true); // 데이터 로딩 시작
      const response = await getObtainsStateSearch(
        Number(orderId),
        data.searchTxt,
      );
      setData(response);
      reset({ searchTxt: '' }); // 검색어 초기화
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };

  const onSubmit = () => {
    // 선택된 아이템들 필터링 및 필요한 필드만 추출
    const selectedItems = data
      ?.filter((_, index: number) => checkedItems[index])
      .map((item) => ({ orderId: item.orderId, obtainId: item.obtainId })); // `orderId`와 `obtainId`만 추출

    // Recoil 상태에 저장
    setSelectedItems(selectedItems || []);

    console.log('Checked Items: ', selectedItems);
    history.push('/manager/order/status/alert');
  };

  const handleCheckboxChange = (index: any) => {
    setCheckedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const getStateListData = async () => {
      if (orderId !== null) {
        try {
          setLoading(true); // 데이터 로딩 시작
          const response = await getObtainsStateList(orderId);
          setData(response);
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false); // 데이터 로딩 완료
        }
      } else {
        setData(null); // orderId가 null일 경우 데이터 비우기
        setLoading(false); // 로딩 상태 해제
      }
    };

    getStateListData();
  }, [orderId]); // orderId가 변경될 때마다 useEffect 실행

  if (loading) {
    return <p>Loading...</p>; // 로딩 상태 표시
  }

  if (!data || data.length === 0) {
    return (
      <Container>
        <SearchForm>
          <form onSubmit={handleSubmit(onSubmitSearch)}>
            <input
              type="text"
              {...register('searchTxt')}
              placeholder="검색어를 입력하세요."
            />
            <div className="icon-box">
              <button>
                <SearchLineIcon />
              </button>
            </div>
          </form>
        </SearchForm>
        <div className="no-data">검색 결과가 없습니다.</div>
      </Container>
    ); // 데이터가 없을 때 표시
  }

  return (
    <Container>
      <SearchForm>
        <form onSubmit={handleSubmit(onSubmitSearch)}>
          <input
            type="text"
            {...register('searchTxt')}
            placeholder="검색어를 입력하세요."
          />
          <div className="icon-box">
            <button>
              <SearchLineIcon />
            </button>
          </div>
        </form>
      </SearchForm>
      <OrderStatusSection>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ul>
            {data.map(
              (item, i) =>
                item ? ( // item과 obtain_id가 존재하는지 확인
                  <li key={i}>
                    <div className="check-box">
                      <Controller
                        name={`checkBtnItems[${i}]`}
                        control={control}
                        render={({ field }) => (
                          <input
                            type="checkbox"
                            id={item.obtainId.toString()}
                            {...field}
                            checked={!!checkedItems[i]}
                            onChange={() => handleCheckboxChange(i)}
                          />
                        )}
                      />
                      <label htmlFor={item.obtainId.toString()}>
                        <div className="l-box">
                          <span className="title">차량번호</span>
                          <span className="car-no">{item.vehicle}</span>
                        </div>
                        <div className="r-box">
                          <span>
                            도착 날짜 <span>{formatDate(item.target)}</span>
                          </span>
                          <span>
                            수주 시간{' '}
                            <span>{formatDateTime(item.obtainCreatedAt)}</span>
                          </span>
                        </div>
                      </label>
                    </div>
                  </li>
                ) : null, // item이나 obtain_id가 존재하지 않을 경우 null 반환
            )}
          </ul>
          <div className="btn-box">
            <button>알림 선택</button>
          </div>
        </form>
      </OrderStatusSection>
    </Container>
  );
};

export default OrderStatus;

//style
const Container = styled.div`
  padding: 0 2.2rem;
  .no-data {
    font-size: 1.6rem;
    text-align: center;
  }
`;

const SearchForm = styled.div`
  background-color: ${(props) => props.theme.textWhiteColor};
  display: flex;
  align-items: center;
  border-radius: 1.2rem;
  border: 1px solid ${(props) => props.theme.searchBoxBorderedColor};
  overflow: hidden;
  margin-top: 1.5rem;
  margin-bottom: 2.4rem;
  height: 4.2rem;
  form {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0 4.2rem 0 1.8rem;
    input {
      flex: 1;
      border: none;
      &::placeholder {
        color: ${(props) => props.theme.searchPlaceholderColor};
      }
    }
  }
  .icon-box {
    display: flex;
    button {
      display: flex;
      border: none;
      outline: none;
      background-color: transparent;
      position: absolute;
      top: 0;
      right: 0;
      padding: 0;
      svg {
        path {
          fill: #b0b8c1;
        }
      }
    }
  }
`;

const OrderStatusSection = styled.section`
  ul {
    li {
      .check-box {
        padding: 1.6rem 0;
        input[type='checkbox'] {
          display: none;
        }
        label {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 3.8rem;
          .l-box {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;
            span.title {
              font-size: 1.2rem;
              font-weight: 600;
              color: ${(props) => props.theme.textAAAColor};
            }
            span.car-no {
              font-size: 1.4rem;
              font-weight: 600;
            }
          }
          .r-box {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;
            span {
              font-size: 1.2rem;
              font-weight: 600;
              color: ${(props) => props.theme.textAAAColor};
              span {
                margin-left: 1.4rem;
                font-size: 1.2rem;
                color: ${(props) => props.theme.textDefaultColor};
              }
            }
          }
          &::after {
            content: '';
            width: 2.2rem;
            height: 2.2rem;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 2.2rem;
            height: 2.2rem;
            border-radius: 2.2rem;
            background: url('/assets/checkbox-nofill.svg');
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
          }
        }
        input[type='checkbox']:checked + label::after {
          background: url('/assets/checkbox-checked22px.svg');
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
        }
      }
    }
  }
  .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 2rem 3.2rem;
    background-color: ${(props) => props.theme.textWhiteColor};
    button {
      width: 100%;
      background-color: ${(props) => props.theme.btnBlueColor};
      color: ${(props) => props.theme.textWhiteColor};
      padding: 1.7rem;
      border-radius: 1.2rem;
      border: 0;
      outline: none;
      font-size: 1.8rem;
      font-weight: 600;
    }
  }
`;
